import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ConfirmDialog from "../../core/ConfirmDialog";

export default function ConfirmModal({ enableButton, operation, buttonText, buttonColor = "primary", modalTitle, modalMessage, modalNewLineMessage, warningMessage }) {
    const theme = useTheme();
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const handleOpenModal = () => {
        setConfirmModalOpen(true);
    };

    const handleCloseModal = () => {
        setConfirmModalOpen(false);
    };

    const handleConfirm = () => {
        operation();
        setConfirmModalOpen(false);
    };

    return (
        <div
            className={{
                alignItems: "center",
                marginTop: theme.spacing(2),
            }}
        >
            <ConfirmDialog
                open={confirmModalOpen}
                handleClose={handleCloseModal}
                handleConfirm={handleConfirm}
                title={modalTitle}
                message={modalMessage}
                newLineMessage={modalNewLineMessage}
                warningMessage={warningMessage}
            />
            <Button
                variant="contained"
                color={buttonColor}
                styleClass={{ height: "50px" }}
                onClick={handleOpenModal}
                disabled={!enableButton}
            >
                {buttonText}
            </Button>
        </div>
    );
}
